<template>
  <div class="crumb-title">
    <div class="crumb-box">
      <a-breadcrumb separator="/">
        <template v-if="Object.prototype.toString.call(roots)=='[object Array]'">
          <a-breadcrumb-item
            v-for="item in roots"
            :key="item.to"
          >
            <router-link
              :to="{ name: item.to,
                     params: {
                       pid
                     },
                     query: {
                       ...item.query
                     }
              }"
              class="config-index"
            >
              {{ item.title }}
            </router-link>
          </a-breadcrumb-item>
        </template>
        <template v-else>
          <a-breadcrumb-item>
            <router-link
              :to="{ name: roots.to,
                     params: {
                       pid
                     },
                     query: {
                       ...roots.query
                     }
              }"
              class="config-index"
            >
              {{ roots.title }}
            </router-link>
          </a-breadcrumb-item>
        </template>
        <a-breadcrumb-item><slot name="breadTit" /></a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="second-tit">
      <h2>
        <slot name="secondTit" />
      </h2>
    </div>
  </div>
</template>
<script>
import i18n from '@/lib/language'
// i18n.t('message["3"]')
export default {
  props: {
    roots: {
      type: [Object, Array],
      default: () => ({ 'to': 'configIndex', 'title': i18n.t('message["1326"]'), 'query': {} })
    }
  },
  computed: {
    pid () {
      return this.$store.state.pid
    }
  }
}
</script>

<style lang="scss" >
.crumb-title {
  padding-top: 16px;
  .crumb-box {
    .ant-breadcrumb {
      font-size: 12px;
      .ant-breadcrumb-separator {
        color: #b3b3b3;
      }
    }
    .config-index {
      color: #5077aa
    }
    .ant-breadcrumb-link {
      color: #5077aa !important;
      span {
        color: #b3b3b3;
      }
    }
  }
  .second-tit {
    h2{
      height: 56px;
      line-height: 56px;
      font-size: 32px;
      font-weight: bold;
      span {
        font-weight: 600
      }
    }
  }
}
</style>
